module.exports = __webpack_public_path__ + "static/media/agile-team.86936f19.png";